(function () {
  var MK = window.MK || {};
  var $ = function (id) { return document.getElementById(id); };

  function money(cents) {
    var v = (cents / 100).toFixed(2);
    var fmt = MK.moneyFormat || '€{{amount_with_comma_separator}}';
    return fmt
      .replace('{{amount_with_comma_separator}}', v.replace('.', ','))
      .replace('{{amount_no_decimals_with_comma_separator}}', Math.round(cents / 100))
      .replace('{{amount_no_decimals}}', Math.round(cents / 100))
      .replace('{{amount}}', v);
  }

  function toast(msg) {
    var t = $('toast'); if (!t) return;
    t.textContent = msg; t.classList.add('show');
    clearTimeout(t._h); t._h = setTimeout(function () { t.classList.remove('show'); }, 2200);
  }

  function esc(s) { var d = document.createElement('div'); d.textContent = s; return d.innerHTML; }

  function renderDrawer(cart) {
    $('count').textContent = cart.item_count;
    var box = $('ditems'), foot = $('dfoot');
    if (!box) return;
    if (!cart.items.length) {
      box.innerHTML = '<div class="empty">🍯<br>' + esc(MK.t.empty) + '</div>';
      foot.style.display = 'none';
      return;
    }
    foot.style.display = 'grid';
    box.innerHTML = cart.items.map(function (it) {
      var img = it.image ? it.image + (it.image.indexOf('?') > -1 ? '&' : '?') + 'width=160' : '';
      return '<div class="ditem">' +
        (img ? '<img src="' + img + '" alt="">' : '<div></div>') +
        '<div><h4>' + esc(it.product_title) + '</h4>' +
        '<div class="qty"><button data-key="' + it.key + '" data-q="' + (it.quantity - 1) + '">−</button><span>' + it.quantity +
        '</span><button data-key="' + it.key + '" data-q="' + (it.quantity + 1) + '">+</button></div></div>' +
        '<div style="text-align:right"><b>' + money(it.final_line_price) + '</b><br>' +
        '<button class="rm" data-key="' + it.key + '" data-q="0">' + esc(MK.t.remove) + '</button></div></div>';
    }).join('');
    $('dsub').textContent = money(cart.total_price);
  }

  function getCart() { return fetch(MK.cartUrl + '.js').then(function (r) { return r.json(); }); }

  function openDrawer() { $('drawer').classList.add('open'); $('shade').classList.add('open'); }
  function closeDrawer() { $('drawer').classList.remove('open'); $('shade').classList.remove('open'); }

  function change(key, q) {
    return fetch(MK.changeUrl + '.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: q })
    }).then(function (r) { return r.json(); }).then(renderDrawer);
  }

  // add to cart (AJAX) for any form marked data-ajax-add
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f.matches || !f.matches('form[data-ajax-add]')) return;
    e.preventDefault();
    var btn = f.querySelector('[type=submit]'); if (btn) btn.disabled = true;
    fetch(MK.addUrl + '.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: new FormData(f) })
      .then(function (r) { if (!r.ok) throw r; return r.json(); })
      .then(function () { return getCart(); })
      .then(function (cart) { renderDrawer(cart); openDrawer(); toast(MK.t.added); })
      .catch(function () { toast(MK.t.error); })
      .finally(function () { if (btn) btn.disabled = false; });
  });

  document.addEventListener('click', function (e) {
    var b = e.target.closest('#ditems button[data-key]');
    if (b) { change(b.getAttribute('data-key'), parseInt(b.getAttribute('data-q'), 10)); return; }
    var q = e.target.closest('[data-qty-step]');
    if (q) {
      var inp = document.getElementById(q.getAttribute('data-target'));
      var v = Math.max(1, (parseInt(inp.value, 10) || 1) + parseInt(q.getAttribute('data-qty-step'), 10));
      inp.value = v;
    }
    var th = e.target.closest('[data-thumb]');
    if (th) {
      $('ppMain').src = th.getAttribute('data-thumb');
      document.querySelectorAll('[data-thumb]').forEach(function (x) { x.classList.remove('on'); });
      th.classList.add('on');
    }
  });

  var oc = $('openCart');
  if (oc && !document.body.classList.contains('template-cart')) {
    oc.addEventListener('click', function (e) { e.preventDefault(); getCart().then(renderDrawer); openDrawer(); });
  }
  if ($('closeCart')) $('closeCart').onclick = closeDrawer;
  if ($('shade')) $('shade').onclick = closeDrawer;
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });

  // Cart page: Tallinn postal code check before checkout
  var zip = $('zip');
  if (zip) {
    var min = parseInt(zip.getAttribute('data-min'), 10), max = parseInt(zip.getAttribute('data-max'), 10);
    var warn = $('zipWarn'), co = $('checkoutBtn');
    var check = function () {
      var v = (zip.value || '').trim(), n = parseInt(v, 10);
      var ok = /^\d{5}$/.test(v) && n >= min && n <= max;
      warn.textContent = !v ? warn.getAttribute('data-empty') : ok ? '' : warn.getAttribute('data-bad');
      warn.style.color = ok ? '' : (v ? 'var(--rasp)' : 'var(--muted)');
      co.disabled = !ok;
      try { if (ok) localStorage.setItem('mk_zip', v); } catch (err) {}
    };
    try { var saved = localStorage.getItem('mk_zip'); if (saved) zip.value = saved; } catch (err) {}
    zip.addEventListener('input', check); check();
  }
})();
